import { useMemo, useState } from "react";

import type { EnrichmentJobMappingDTO } from "../types/types";
import { isPredefinedField, isTechnologiesField } from "../utils/mappingValidation";

const useMappingTableFocus = (mappings: readonly EnrichmentJobMappingDTO[]) => {
    const [manuallyFocusedIdx, setManuallyFocusedIdx] = useState<number | null>(null);

    const focusIndexes = useMemo(
        () =>
            mappings.reduce<number[]>((acc, mapping, index) => {
                const needsFocus =
                    !mapping.externalField ||
                    (isTechnologiesField(mapping.sourceType) && !mapping.metadata) ||
                    (isPredefinedField(mapping.sourceType) && !mapping.metadata);
                if (needsFocus) {
                    acc.push(index);
                }
                return acc;
            }, []),
        [mappings],
    );

    const focusIdx = focusIndexes[0] ?? 0;

    return {
        focusIdx,
        manuallyFocusedIdx,
        setManuallyFocusedIdx,
        activeFocusIdx: manuallyFocusedIdx ?? focusIdx,
    };
};

export default useMappingTableFocus;
